







    import {Component, Mixins, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
    import MonitorMixin from "@/design-system/utilities/MonitorMixin"

@Component
export default class JdhHeightTransition extends Mixins(MonitorMixin) {
    @Ref() innerEl!: HTMLElement
    @Prop({type: Boolean, default: false}) pause!: boolean

    observer?: ResizeObserver|null = null;
    holdHeight: number|null = null;

    errorMode = false

    mounted(){
        this.holdHeight = this.innerEl.getBoundingClientRect().height;
        this.$nextTick(() => {
            this.observer = new ResizeObserver(entries => {
                for (let entry of entries) {
                    if (!this.pause && this.innerEl) {
                        try {
                            this.holdHeight = this.innerEl.getBoundingClientRect().height;
                        } catch (e) { }
                    }
                }
            })

            if (this.innerEl instanceof Element) {
                this.errorMode = false
                this.observer.observe(this.innerEl)
            } else {
                this.errorMode = true
                this.$warn('Unable to track element for height transition.', "NO_EL", {el: this.innerEl})
            }
        })
    }

    get styles() {
        if (this.errorMode) {
            return {}
        }
        return {
            height: this.holdHeight +'px'
        }
    }

    @Watch('pause')
    resume(newValue: boolean, oldValue: boolean) {
        if (newValue) {
            this.holdHeight = this.innerEl.getBoundingClientRect().height;
        }
    }

    beforeDestroy(){
        delete this.observer
    }
}
